wbApp.directive('wbConsentDefinitionCombo', ['$timeout', '$translate', 'consentDefinitionSvc',
    function ($timeout, $translate, consentDefinitionSvc) {
        function formatResult(model) {
            if (!model) { return; }

            var name;
            if (!model.active) {
                name = model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
            } else {
                name = model.name;
            }

            return name;
        }

        function formatSelection(model) {
            if (!model.active) {
                return model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
            } else {
                return model.name;
            }
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,            
            link: function (scope, elm, attrs, ctrl) {
               
                $timeout(function () {

                    var models = consentDefinitionSvc.getAllActiveAsync(false, ctrl.$modelValue);

                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_CONSENT_DEFINITION'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: 5,
                        data: models,
                        id: function (consentDefinition) { return consentDefinition.consentDefinitionID; },
                        matcher: function (term, text, data) {
                            return data.name.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                        }
                    });

                    ctrl.$render = function () {
                        models.$promise.then(function () {
                            $timeout(function () {
                                $(elm).select2('val', ctrl.$viewValue);
                            });
                        });
                    }

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                elm.on('change', function (e) {
                    scope.$apply(function () {
                        ctrl.$setViewValue(e.val);
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);    